import { bodyStylesList } from '@carvana/merch-search-bar';
import { useContext } from 'react';
import PopularVehicleStyles from '@/common/PopularVehicleStyles';
import SectionWrapper from '@/common/SectionWrapper';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import type { AppliedFilters } from '~/contracts/common';

const POPULAR_VEHICLE_STYLES_COUNT = 6;

export default function PopularVehicleStylesRow() {
  const { setAppliedFilters } = useContext(AppliedFiltersContext);

  return (
    <SectionWrapper
      analyticsSection="Popular Vehicle Styles"
      eventName="Free Text No Results Section"
      hasBackground={false}
    >
      <PopularVehicleStyles
        items={bodyStylesList.slice(0, POPULAR_VEHICLE_STYLES_COUNT)}
        onSelect={bodyStyle =>
          // The search-bar package's own AppliedFilters type allows null values;
          // ours doesn't. bodyStylesList's static entries never contain null.
          setAppliedFilters(bodyStyle.filters as Partial<AppliedFilters>)
        }
      />
    </SectionWrapper>
  );
}
